export default {
  "content": "<path fill=\"#707070\" d=\"M2 4.5A2.5 2.5 0 014.5 2h15A2.5 2.5 0 0122 4.5v10a2.5 2.5 0 01-2.5 2.5h-15A2.5 2.5 0 012 14.5v-10zm4.11 16.87V17h6.51l-5.46 4.84a.63.63 0 01-1.05-.47z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24"
  }
};